import React, { useState } from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import Typography from '@mui/material/Typography'
import { Box, TextField, MenuItem } from '@mui/material';
import { useQuery } from 'react-query';
import { getStudentData } from '../_api';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useSelector } from 'react-redux';
import LogoImage from './LogoImage';
import { useTranslation } from 'react-i18next';
import LanguageSelectorDialog from './LanguageSelectorDialog';
import isI18nEnabled from './isI18nEnabled';

export default function WelcomeDialog({ open, setOpen, setOpenTutorials }) {
    const { t } = useTranslation();
    const welcomeMessage = useSelector(state => state.user.userData?.welcomeMessage) || ""
    const user = useSelector(state => state.user.userData?.user)
    const { data } = useQuery("student-data",()=> getStudentData(user?.organizationId))
    const isTutorial = useSelector(state => state.user.userData?.isTutorial) || false
    const [schoolDisabled, setSchoolDisabled] = useState(false)

    const validationSchema = Yup.object({
        email: Yup.string()
            .email(t('validEmail'))
            .required(t('requiredEmail')),
        name: Yup.string().required(t('requiredFirstName')),
        lastName: Yup.string().required(t('requiredLastName')),
        schoolName: user?.organizationId === 13 ? Yup.string().required(t('requiredSchoolName')) : Yup.string()
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            name: "",
            lastName: "",
            schoolName: ""
        },
        validationSchema: validationSchema,
        onSubmit: (values, { setSubmitting }) => {
            setSubmitting(true);
            let userDetials = {}

            const studentData = data?.find(student => student.email === values.email);
            if (studentData && user?.organizationId == 13) {
                userDetials = {
                    coach: studentData?.coach || "Dummy",
                    mentor: studentData?.mentor || "Dummy",
                    name: values.name,
                    lastName: values.lastName,
                    schoolName: values.schoolName || studentData?.schoolName
                }
            } else {
                userDetials = {
                    coach: "Dummy",
                    mentor: studentData?.mentor || "Dummy",
                    name: values.name,
                    lastName: values.lastName,
                    schoolName: values.schoolName || ""
                }
            }
            localStorage.setItem("userEmail", values.email)
            localStorage.setItem("userDetails", JSON.stringify(userDetials))
            setOpen(false);
            if (isTutorial) {
                setOpenTutorials(true)
            }
            localStorage.setItem(`hasVisitedMyPage`, 'true');
            setSubmitting(false);
        },
    });

    const handleEmailChange = (e) => {
        formik.handleChange(e);
        const studentData = data?.find(student => student.email === e.target.value);
        if (studentData) {
            formik.setFieldValue('schoolName', studentData.schoolName);
            setSchoolDisabled(true);
        } else {
            formik.setFieldValue('schoolName', '');
            setSchoolDisabled(false);
        }
    };

    const handleClose = () => {
        formik.handleSubmit();
    };

    // Get unique school names from data
    const schoolOptions = [...new Set(data?.map(student => student.schoolName) || [])];

    return (
        <Dialog
            open={open}
            // onClose={handleClose}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            PaperProps={{
                sx: {
                    borderRadius: "32px",
                    maxWidth: 'md',

                }
            }}
        >
            <DialogContent>
                <Box sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    gap: "15px",
                    position: "relative"
                }}>
                    {
                        isI18nEnabled(user?.organizationId) && (
                            <Box sx={{
                                position: "absolute",
                                top: "0px",
                                right: "10px"
                            }}>
                                <LanguageSelectorDialog />
                            </Box>
                        )
                    }
                    <LogoImage biggerLogo={user?.organizationId == "58" || user?.organizationId == "75"} />
                    <img width={"30%"} src="/assets/img/welcomeillustration.png" alt="" />
                    <Typography textAlign={"center"} variant="body" color="initial">
                        {welcomeMessage}
                    </Typography>
                    <TextField
                        fullWidth
                        label={t('enterFirstName')}
                        name="name"
                        value={formik.values.name}
                        onChange={formik.handleChange}
                        error={formik.touched.name && Boolean(formik.errors.name)}
                        helperText={formik.touched.name ? formik.errors.name : ""}
                    />
                    <TextField
                        fullWidth
                        name="lastName"
                        label={t('enterLastName')}
                        value={formik.values.lastName}
                        onChange={formik.handleChange}
                        error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                        helperText={formik.touched.lastName ? formik.errors.lastName : ""}
                    />
                    <TextField
                        fullWidth
                        name="email"
                        label={t('enterEmail')}
                        value={formik.values.email}
                        onChange={handleEmailChange}
                        onKeyPress={(e) => e.key === 'Enter' && formik.handleSubmit()}
                        error={formik.touched.email && Boolean(formik.errors.email)}
                        helperText={formik.touched.email ? formik.errors.email : ""}
                    />
                    {user?.organizationId === 13 && (
                        <TextField
                            select
                            fullWidth
                            name="schoolName"
                            label={t('schoolName')}
                            value={formik.values.schoolName}
                            onChange={formik.handleChange}
                            disabled={schoolDisabled}
                            error={formik.touched.schoolName && Boolean(formik.errors.schoolName)}
                            helperText={formik.touched.schoolName ? formik.errors.schoolName : ""}
                        >
                            {schoolOptions.map((school) => (
                                <MenuItem key={school} value={school}>
                                    {school}
                                </MenuItem>
                            ))}
                        </TextField>
                    )}
                    <Button sx={{ px: 4 }} variant='contained' onClick={handleClose}>
                        {t('submit')}
                    </Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}